// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentTop_wrapper__2SyPp"};